export const isValidCoord = ([lon, lat]) => {
    if (typeof lon !== "number" || typeof lat !== "number") return false;
    if (Number.isNaN(lon) || Number.isNaN(lat)) return false;
  
    if (lon < -180 || lon > 180 || lat < -90 || lat > 90) return false;
  
    if (lat < 41 || lat > 43) return false;
    if (lon < 20 || lon > 22) return false;
  
    return true;
  };
  